import { render, staticRenderFns } from "./VocabularySessionPrimary.vue?vue&type=template&id=2737a578&scoped=true"
import script from "./VocabularySessionPrimary.vue?vue&type=script&lang=js"
export * from "./VocabularySessionPrimary.vue?vue&type=script&lang=js"
import style0 from "./VocabularySessionPrimary.vue?vue&type=style&index=0&id=2737a578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2737a578",
  null
  
)

export default component.exports